(function () {
  const LIST_ID = 'S9B8tD';
  const DEFAULT_USE_CASE = 'USE_CASE_PHONE';

  function getSource(form) {
    if (form.closest('.ms-footer-newsletter, .footer-block--contact_information')) return 'footer';
    if (form.closest('.ms-home-newsletter, .section-mindsight-home-newsletter')) return 'homepage_newsletter';
    return 'newsletter';
  }

  async function subscribeKlaviyo(email, source) {
    window._learnq = window._learnq || [];
    window._learnq.push([
      'identify',
      {
        $email: email,
        popup_use_case: DEFAULT_USE_CASE,
        popup_source: source,
      },
    ]);
    window._learnq.push([
      'track',
      'Newsletter Signup',
      {
        popup_use_case: DEFAULT_USE_CASE,
        popup_source: source,
      },
    ]);

    const companyId = window.__klaviyoCompanyId;
    if (!companyId) return true;

    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-07-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    properties: {
                      popup_use_case: DEFAULT_USE_CASE,
                      popup_source: source,
                    },
                  },
                },
              },
            },
            relationships: {
              list: { data: { type: 'list', id: LIST_ID } },
            },
          },
        }),
      }
    );

    if (!response.ok && response.status !== 202) {
      throw new Error('Klaviyo subscribe failed');
    }
    return true;
  }

  function showSuccess(form) {
    const modal = form.querySelector('[id*="NewsletterAlertModal-"]');
    const success = form.querySelector('[id*="Newsletter-success-"]');
    const error = form.querySelector('[id*="Newsletter-error-"]');
    error?.classList.add('hidden');
    if (success) {
      success.classList.remove('hidden');
      modal?.show?.();
      window.isNewsletterModalShow = true;
      return;
    }
    const wrapper = form.closest('.newsletter-form') || form.parentElement;
    if (!wrapper || wrapper.querySelector('.ms-newsletter-inline-success')) return;
    const note = document.createElement('p');
    note.className = 'ms-newsletter-inline-success';
    note.textContent = "You're in — check your inbox.";
    note.style.cssText = 'margin:12px 0 0;font-size:14px;color:#6286c7;font-weight:600;';
    wrapper.appendChild(note);
    form.querySelector('input[type="email"]')?.setAttribute('disabled', 'disabled');
    form.querySelector('button[type="submit"]')?.setAttribute('disabled', 'disabled');
  }

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest(
        '.ms-footer-newsletter form[is="newsletter-form"], .ms-home-newsletter form[is="newsletter-form"], .section-mindsight-home-newsletter form[is="newsletter-form"]'
      );
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();

      const input = form.querySelector('input[type="email"]');
      const email = input?.value?.trim();
      if (!email || !input?.checkValidity()) {
        input?.reportValidity();
        return;
      }

      const button = form.querySelector('button[type="submit"]');
      const original = button?.textContent;
      if (button) {
        button.disabled = true;
        button.textContent = 'Subscribing…';
      }

      try {
        await subscribeKlaviyo(email, getSource(form));
        showSuccess(form);
      } catch {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
        form.submit();
      }
    },
    true
  );
})();
